import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1800,1740 C1800,1773 1773,1800 1740,1800 L1320,1800 L1320,1500 L1200,1500 L1200,1800 L720,1800 L720,1500 L600,1500 L600,1800 L180,1800 C146.88,1800 120,1773 120,1740 L120,180 C120,147 146.88,120 180,120 L600,120 L600,420 L720,420 L720,120 L1200,120 L1200,420 L1320,420 L1320,120 L1740,120 C1773,120 1800,147 1800,180 L1800,1740 Z M1740,1.13686838e-13 L180,1.13686838e-13 C80.76,1.13686838e-13 -1.13686838e-13,80.76 -1.13686838e-13,180 L-1.13686838e-13,1740 C-1.13686838e-13,1839.24 80.76,1920 180,1920 L1740,1920 C1839.24,1920 1920,1839.24 1920,1740 L1920,180 C1920,80.76 1839.24,1.13686838e-13 1740,1.13686838e-13 L1740,1.13686838e-13 Z M1265,1434.68 L1434.68,1265 L1129.52,959.84 L1434.68,654.68 L1265,485 L959.84,790.16 L654.68,485 L485,654.68 L790.16,959.84 L485,1265 L654.68,1434.68 L959.84,1129.52 L1265,1434.68 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1",
  transform: "rotate(90 960 960)"
});

var IconTableDeleteRowLine = /*#__PURE__*/function (_Component) {
  _inherits(IconTableDeleteRowLine, _Component);

  var _super = _createSuper(IconTableDeleteRowLine);

  function IconTableDeleteRowLine() {
    _classCallCheck(this, IconTableDeleteRowLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconTableDeleteRowLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTableDeleteRow",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTableDeleteRowLine.displayName = "IconTableDeleteRowLine";
  return IconTableDeleteRowLine;
}(Component);

IconTableDeleteRowLine.glyphName = 'table-delete-row';
IconTableDeleteRowLine.variant = 'Line';
IconTableDeleteRowLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTableDeleteRowLine;
export { IconTableDeleteRowLine };